// The version of the Run The Club terms a club agrees to. Matches backend/config/terms.js.
export const TERMS_VERSION = '2026-10-21';
export const TERMS_URL = 'https://runthe.club/terms.html';
export const DPA_URL = 'https://runthe.club/dpa.html';
